<template>
  <div class="order-edit-page">
    <Button type="primary" icon="ios-arrow-back" @click="back">{{$t('Order.Return_to_Order_list')}}</Button>
    <Card class="edit-card">
        <div style="text-align:center">
          <h4>{{title}}</h4>
          <Form class="edit-form" :label-width="100" inline style="border-bottom-style: solid" :model="formValidate" :rules="ruleValidate">
            <Row>
              <i-Col span="6">
                <FormItem :label="$t('Order.orderNo')" prop="orderNo">
                  <Input class="info" v-model="formValidate.orderNo" :placeholder="$t('Order.please_enter')"></Input>
                </FormItem>
              </i-Col>
              <i-Col span="6">
                <FormItem :label="$t('Order.ordersTime')" prop="ordersTime">
                  <DatePicker class="info" @on-change="ordersTimeChange" type="date" :value="formValidate.ordersTime" :placeholder="$t('Order.please_enter_date')"></DatePicker>
                </FormItem>
              </i-Col>
              <i-Col span="6">
                <FormItem :label="$t('Order.customer')">
                  <Input class="info" v-model="formValidate.customer" :placeholder="$t('Order.please_enter')"></Input>
                </FormItem>
              </i-Col>
              <i-Col span="6">
                <FormItem :label="$t('Order.salesman')">
                  <Input class="info" v-model="formValidate.salesman" :placeholder="$t('Order.please_enter')"></Input>
                </FormItem>
              </i-Col>
            </Row>
            </Form>
          <div class="right-side side">
            <Row class="search-area">
              <!-- <Col span="14">
                  <Input size="small" type="text" v-model="search" placeholder="编号/名称"></Input>
              </Col>
              <Col span="4" offset="1">
                  <Button size="small" type="ghost" @click="handleSearch()">搜索</Button>
              </Col>
              <Col span="4" offset="1">
                  <Button size="small" type="ghost" @click="handleReset()">重置</Button>
              </Col> -->
              <Input type="text" v-model="search" :placeholder="$t('Order.search')">
                 <Button slot="append" icon="ios-search" @click="handleSearch()"></Button>
                 <Button slot="append" icon="refresh" @click="handleReset()"></Button>
              </Input>
            </Row>
            <Table class="product-table" highlight-row stripe border :columns="columns" @on-current-change="productSelect" :data="products"></Table>
          </div>
          <div class="left-side side">
            <Card>
              <Form class="edit-product-form" :label-width="60" inline>
                <p>{{currentSelect.productNo}}/{{currentSelect.name}}</p>
                <Row>
                  <i-Col span="7">
                    <FormItem :label="$t('Order.num')">
                      <Input size="small" class="info" v-model="currentSelect.num" :placeholder="$t('Order.please_enter')"></Input>
                    </FormItem>
                  </i-Col>
                  <i-Col span="7">
                    <FormItem :label="$t('Order.unit')">
                      <Select size="small" class="info" v-model="currentSelect.currentUnit" :value="currentUnit">
                        <!-- <Option v-for="i in [$t('Order.Meter'),$t('Order.Yard'),$t('Order.Gross')]" :value="i" :key="i">{{ i }}</Option> -->
                        <Option value="1" key= 1>{{$t('Order.Meter')}}</Option>
                        <Option value="2" key= 2>{{$t('Order.Yard')}}</Option>
                        <Option value="3" key= 3>{{$t('Order.Gross')}}</Option>
                      </Select>
                    </FormItem>
                  </i-Col>
                  <i-Col span="9">
                    <FormItem :label="$t('Order.deliveryTime')">
                      <DatePicker class="info" type="date" @on-change="deliveryTimeChange" :value="currentDeliveryTime" :placeholder="$t('Order.please_enter_date')"></DatePicker>
                    </FormItem>
                  </i-Col>
                </Row>
                <Row>
                  <i-Col span="7">
                    <FormItem :label="$t('Order.attritionRate')">
                      <Input size="small" class="info" v-model="currentSelect.attritionRate" :placeholder="$t('Order.please_enter')"></Input>
                    </FormItem>
                  </i-Col>
                  <i-Col span="7">
                    <FormItem :label="$t('Order.remark')">
                      <Input size="small" class="info" v-model="currentSelect.remark" :placeholder="$t('Order.please_enter')"></Input>
                    </FormItem>
                  </i-Col>
                </Row>
                <div class="save-btn"><Button size="small" type="primary" @click="add()">{{$t('Order.add')}}</Button></div>
              </Form>
            </Card>
            <Form class="edit-form" :label-width="100" inline>
              <p class="order-product-title">{{$t('Order.Product_list')}}</p>
              <Table class="order-product-table" highlight-row stripe border :columns="orderProductColumns" :data="orderProduct"></Table>
              <hr>
              <div class="save-btn">
                <Button type="primary" @click="save()">{{$t('Order.save')}}</Button>
              </div>
            </Form>
          </div>
          <div class="bottom-side"></div>
        </div>
    </Card>
  </div>
</template>
<script>
import {Api} from '@/api'
export default {
  name: 'OrderEdit',
  data () {
    return {
      id: 0,
      formValidate: {
        orderNo: '',
        ordersTime: '',
        customer: '',
        salesman: ''
      },
      ruleValidate: {
        orderNo: [
          { required: true, message: this.$t('Order.Message.orderNo'), trigger: 'blur' }
        ],
        ordersTime: [
          { required: true, message: this.$t('Order.Message.ordersTime'), pattern: /.+/, trigger: 'blur' }
        ],
        customer: [
          { required: true, message: this.$t('Order.Message.customer'), trigger: 'change' }
        ],
        salesman: [
          { required: true, message: this.$t('Order.Message.salesman'), trigger: 'blur' }
        ]
      },
      valid: 0,
      search: '',
      columns: [
        { title: this.$t('Order.productNo'), key: 'productNo' },
        { title: this.$t('Order.name'), key: 'name' }
        // { title: '纬密', key: 'latDensity' },
        // { title: '宽度', key: 'width' }
      ],
      orderProductColumns: [
        { title: this.$t('Order.productNo'), key: 'productNo' },
        { title: this.$t('Order.name'), key: 'name' },
        { title: this.$t('Order.num'), key: 'num' },
        { title: this.$t('Order.unit'), key: 'unit_show' },
        { title: this.$t('Order.attritionRate'), key: 'attritionRate' },
        { title: this.$t('Order.deliveryTime'), key: 'deliveryTime' },
        { title: this.$t('Order.remark'), key: 'remark' },
        {
          title: this.$t('Order.action'),
          key: 'action',
          render: (h, params) => {
            // console.log(params, params.row)
            if (params.row.CPValid === 1 && params.row.PPValid === 1) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: true
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                    }
                  }
                }, this.$t('Order.Scheduling'))
              ])
            } else if (params.row.PPValid === 1) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: true
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                    }
                  }
                }, this.$t('Order.Producting'))
              ])
            } else {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.remove(params.index)
                    }
                  }
                }, this.$t('Order.delete'))
              ])
            }
          }
        }
      ],
      orderProduct: [],
      products: [],
      productList: [],
      currentSelect: {},
      currentDeliveryTime: '',
      currentUnit: '',
      removeIDs: []
    }
  },
  computed: {
    title () {
      return this.id === 0 ? this.$t('Order.New_Order') : this.$t('Order.edit_Order')
    }
  },
  methods: {
    back () {
      this.$router.back()
    },
    remove (index) {
      if (this.id !== 0) {
        this.removeIDs.push(this.orderProduct[index].id)
      }
      this.orderProduct.splice(index, 1)
    },
    save () {
      let order
      // console.log(this.formValidate.orderNo, this.formValidate.ordersTime, this.formValidate.customer, this.formValidate.salesman, this.orderProduct.length)
      // if (this.formValidate.orderNo !== '' && this.formValidate.ordersTime !== '' && this.formValidate.customer !== '' && this.formValidate.salesman !== '' && this.orderProduct.length !== 0) {
      if (this.formValidate.orderNo !== '' && this.formValidate.ordersTime !== '' && this.orderProduct.length !== 0) {
        order = {
          OrderID: this.id,
          orderNo: this.formValidate.orderNo,
          ordersTime: this.formValidate.ordersTime,
          customer: this.formValidate.customer,
          salesman: this.formValidate.salesman,
          orderProducts: this.orderProduct,
          valid: this.valid,
          removeIDs: this.removeIDs
        }
      } else if (this.orderProduct.length === 0) {
        const title = this.$t('Order.error')
        const content = this.$t('Order.error_message1')
        this.$Modal.error({
          title: title,
          content: content
        })
      } else {
        const title = this.$t('Order.error')
        const content = this.$t('Order.error_message2')
        this.$Modal.error({
          title: title,
          content: content
        })
      }
      // console.log(order)
      Api.order.save(order).then(() => {
        this.$router.push({'name': 'OrderList'})
      })
    },
    ordersTimeChange (v) {
      this.formValidate.ordersTime = v
    },
    deliveryTimeChange (v) {
      this.currentDeliveryTime = v
    },
    productSelect (current, old) {
      this.currentSelect = current
    },
    handleSearch () {
      this.products = []
      for (let i = 0; i < this.productList.length; i++) {
        let p = this.productList[i]
        if (p.productNo.indexOf(this.search) !== -1 || p.name.indexOf(this.search) !== -1) {
          this.products.push(p)
        }
      }
    },
    handleReset () {
      this.products = this.productList
    },
    add () {
      if (this.currentSelect.productNo === undefined || this.currentSelect.name === undefined) {
        const title = this.$t('Order.error')
        const content = this.$t('Order.error_message6')
        this.$Modal.error({
          title: title,
          content: content
        })
        return
      }
      if (this.currentSelect.num === undefined) {
        const title = this.$t('Order.error')
        const content = this.$t('Order.error_message3')
        this.$Modal.error({
          title: title,
          content: content
        })
      } else if (this.currentSelect.currentUnit === undefined) {
        const title = this.$t('Order.error')
        const content = this.$t('Order.error_message4')
        this.$Modal.error({
          title: title,
          content: content
        })
      } else if (this.currentDeliveryTime === '') {
        const title = this.$t('Order.error')
        const content = this.$t('Order.error_message5')
        this.$Modal.error({
          title: title,
          content: content
        })
      } else {
        let u = ''
        if (this.currentSelect.currentUnit === '1') {
          u = this.$t('Order.Meter')
        } else if (this.currentSelect.currentUnit === '2') {
          u = this.$t('Order.Yard')
        } else if (this.currentSelect.currentUnit === '3') {
          u = this.$t('Order.Gross')
        }
        // console.log(this.currentSelect.currentUnit, u)
        let ar = Number(this.currentSelect.attritionRate)
        let num = Number(this.currentSelect.num)
        if (ar > 0) {
          num = parseInt(num * (1 + ar / 100))
        }
        this.orderProduct.push({
          productID: this.currentSelect.id,
          productNo: this.currentSelect.productNo,
          name: this.currentSelect.name,
          unit: Number(this.currentSelect.currentUnit),
          unit_show: u,
          attritionRate: ar,
          num: num,
          color: this.currentSelect.color,
          deliveryTime: this.currentDeliveryTime,
          remark: this.currentSelect.remark
        })
      }
      // console.log(this.orderProduct)
    }
  },
  mounted () {
    Api.product.list().then(res => {
      this.productList = res.products
      this.products = res.products
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].valid === 0 || this.products[i].valid === 3) {
          this.products.splice(i, 1)
          i--
        }
      }
      this.productList = this.products
    })
  },
  beforeRouteEnter (to, from, next) {
    let id = Number(to.params.id)
    if (id !== 0) {
      Api.order.get(id).then(res => {
        let o = res.orderInfo
        next(vm => {
          vm.id = o.orderID
          vm.formValidate.orderNo = o.orderNo
          vm.formValidate.ordersTime = o.ordersTime
          vm.deliveryTime = o.deliveryTime
          vm.formValidate.customer = o.customer
          vm.formValidate.salesman = o.salesman
          vm.orderProduct = o.orderProducts
          for (let i = 0; i < vm.orderProduct.length; i++) {
            if (vm.orderProduct[i].unit === 1) {
              vm.orderProduct[i].unit_show = vm.$t('Order.Meter')
            } else if (vm.orderProduct[i].unit === 2) {
              vm.orderProduct[i].unit_show = vm.$t('Order.Yard')
            } else if (vm.orderProduct[i].unit === 3) {
              vm.orderProduct[i].unit_show = vm.$t('Order.Gross')
            }
          }
          // console.log(vm.orderProduct)
        })
      })
    } else {
      next()
    }
  }
}
</script>
<style scoped>
  .order-edit-page {
    padding: 10px;
  }
  .edit-card {
    margin-top: 20px
  }
  .product-table {
    margin-top: 10px;
  }
  .edit-form {
    padding: 20px 0px;
  }
  .edit-form .info {
    width: 100%;
  }
  .edit-product-form .info {
    width: 110px;
    margin-bottom: 0px;
  }
  .edit-product-form .ivu-form-item {
    margin-bottom: 0px;
  }
  .side {
    float: left;
    min-height: 100px;
  }
  .left-side {
    width: 60%;
    padding-left: 20px;
  }
  .right-side {
    padding: 20px 0 0 0;
    width: 40%;
  }
  .bottom-side {
    clear: both;
  }
  hr {
    background-color: #dbdbdb;
    border: none;
    display: block;
    height: 1px;
    margin: 1.5rem 0;
  }
  .save-btn {
    text-align: left;
  }
  .search-area {
    margin-top: 20px;
  }
  .order-product-title {
    text-align: center;
    margin-top: -14px;
    margin-bottom: 10px;
  }
</style>





// WEBPACK FOOTER //
// Edit.vue?71b89cdc